import {useEffect, Suspense} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import ReactGA from 'react-ga4'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'

const App = () => {
  const location = useLocation()

  useEffect(() => {
    ReactGA.initialize('G-QH7HBQHSNP')
  }, [])

  useEffect(() => {
    ReactGA.send({hitType: 'pageview', page: location.pathname})
  }, [location])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
